import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/routes.constants";
import { useDispatch } from "react-redux";
import { userSlice } from "../../redux/slices/user.slice";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all cookies
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    // Clear Redux state
    dispatch(userSlice.actions.logout());

    // Redirect to login
    navigate(ROUTES.LOGIN_ROUTE);
  }, [dispatch, navigate]);

  return null;
};

export default Logout;
